import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import CompactHeader from '@daedalus/atlas/src/components/shared/general/CompactHeader'
import Overlay from '@daedalus/atlas/src/components/shared/general/Overlay'
import MembershipPageContent from '@daedalus/atlas/src/components/shared/user/MembershipPageContent'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {MOBILE_HEADER_HEIGHT} from '@daedalus/atlas/src/components/shared/general/CompactHeader/constants'

import brand from '../../configs/brand'
import {getMembershipVisibility} from '../../modules/overlay/selectors'
import {changeMembershipVisibility} from '../../modules/overlay/actions'
import getAnonymousId from '../data/URLParams/selectors/getAnonymousId'
import {
  selectIsAuthenticated,
  selectIsLoading
} from '@daedalus/core/src/auth/modules/selectors'
import {
  useIsMemberPlus,
  useLogIn
} from '@daedalus/core/src/auth/modules/useCognito'

const HeaderWrapper = styled('div')(
  ({theme}) => css`
    position: relative;
    z-index: 2;

    box-shadow: ${theme.shadows.action};
  `
)

const OverlaySection = styled('section')`
  height: calc(100% - ${MOBILE_HEADER_HEIGHT}px);
  display: flex;
  flex-direction: column;
`

const MembershipOverlay = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const isMemberPlus = useIsMemberPlus()
  const logIn = useLogIn()
  const isLoading = useSelector(selectIsLoading)
  const anonymousId = useSelector(getAnonymousId)

  const handleHidePreferences = () =>
    dispatch(changeMembershipVisibility(false)())

  const isMembershipVisible = Boolean(useSelector(getMembershipVisibility))

  const overlayHeaderContent = (
    <FormattedMessageWrapper
      id="membership.findhotelMembership"
      defaultMessage="FindHotel membership"
    />
  )

  return (
    <Overlay isOpen={isMembershipVisible}>
      <HeaderWrapper>
        <CompactHeader
          showBackButton
          brand={brand}
          onBackButtonClick={handleHidePreferences}
        >
          {overlayHeaderContent}
        </CompactHeader>
      </HeaderWrapper>
      <OverlaySection>
        <MembershipPageContent
          isMobile
          isOverlay
          isAuthenticated={isAuthenticated}
          isMemberPlus={isMemberPlus}
          logIn={logIn}
          isLoading={isLoading}
          anonymousId={anonymousId}
        />
      </OverlaySection>
    </Overlay>
  )
}

export default MembershipOverlay
